import DateTimeField from "@src/lib/ui/DateTimeField";

import { timezoneChoices } from "@src/features/app/utils/copy";
import { FC } from "react";
import { OrgFormState } from "./useOrgFormState";
import { Input } from "@src/lib/ui/Input";
import { Button } from "@src/lib/ui/Button";
import { Switch } from "@src/lib/ui/Switch";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@src/lib/ui/Select";
import Spacer from "@src/lib/ui/Spacer";
import Text from "@src/lib/ui/Text";

type Props = OrgFormState & { creating?: boolean };

const OrgForm: FC<Props> = (props) => {
  const {
    name,
    deactivatedAt,
    setName,
    setDeactivatedAt,
    startedAt,
    setStartedAt,
    seatsExpected,
    setSeatsExpected,
    timezone,
    setTimezone,
    isTrial,
    setIsTrial,
    embedUrl,
    setEmbedUrl,
    creating,
  } = props;
  return (
    <div className="flex flex-col">
      <Input
        value={name}
        label="Name"
        onChange={(e) => setName(e.target.value)}
      />
      <Spacer size={8} />
      <div className="mb-2 text-xs leading-6 font-semibold text-black">
        Timezone
      </div>
      <Select value={timezone} onValueChange={setTimezone}>
        <SelectTrigger>
          <SelectValue placeholder="US/ET" />
        </SelectTrigger>
        <SelectContent>
          {timezoneChoices.map((tz) => (
            <SelectItem key={tz.value} value={tz.value}>
              {tz.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Spacer size={8} />
      <div className="mb-4">
        <div className="mr-3 mb-2 text-xs leading-6 font-semibold text-black">
          Deactivated at:
        </div>
        <div className="flex items-center gap-2">
          <DateTimeField
            value={deactivatedAt}
            onChange={setDeactivatedAt}
            className="flex-1"
          />
          {deactivatedAt && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setDeactivatedAt(undefined)}
            >
              Clear
            </Button>
          )}
        </div>
      </div>
      <div className="mb-4">
        <div className="mr-3 mb-2 text-xs leading-6 font-semibold text-black">
          Started at
          <Text
            variant="fine-print-description"
            multiline
            className="ml-1.5 inline"
          >
            (used for adoption reporting purposes. Do not set this unless this
            is a customer!)
          </Text>
        </div>
        <div className="flex items-center gap-2">
          <DateTimeField
            value={startedAt}
            onChange={setStartedAt}
            className="flex-1"
          />
          {startedAt && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setStartedAt(undefined)}
            >
              Clear
            </Button>
          )}
        </div>
      </div>
      <Input
        value={seatsExpected.toString()}
        label="Expected Employee Count"
        type="number"
        onChange={(e) => setSeatsExpected(parseInt(e.target.value, 10) || 0)}
      />
      <Spacer size={8} />

      {!creating && (
        <>
          <Input
            value={embedUrl}
            label="Account plan embed URL"
            placeholder="https://..."
            onChange={(e) => setEmbedUrl(e.target.value)}
          />
          <Spacer size={8} />
        </>
      )}

      {creating && (
        <div className="mb-4">
          <div className="mr-3 mb-2 text-xs leading-6 font-semibold text-black">
            Is Trial?
          </div>
          <Switch
            checked={!!isTrial}
            onCheckedChange={(checked) => setIsTrial(checked)}
          />
        </div>
      )}
    </div>
  );
};

export default OrgForm;
